'use client';

import React from 'react';
import Link from 'next/link';

const footerLinks = [
    { href: 'https://www.linkedin.com/company/waitlistly', label: 'LinkedIn', external: true },
    { href: '/help', label: 'Help', external: false },
    { href: '/terms', label: 'Terms', external: false },
    { href: '/privacy', label: 'Privacy', external: false },
    { href: '/contact', label: 'Contact', external: false },
];

export default function Footer() {
    return (
        <footer className="bg-white py-12 pb-28 lg:pb-12 border-t border-gray-200">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div className="flex flex-col md:flex-row justify-between items-center gap-8">
                    {/* Logo */}
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-xl bg-violet-600 flex items-center justify-center shadow-lg shadow-violet-600/20">
                            <span className="text-white font-bold">W</span>
                        </div>
                        <span className="text-lg font-bold text-gray-900">Waitlistly</span>
                    </div>

                    {/* Links - stacks on mobile */}
                    <div className="flex flex-wrap justify-center items-center gap-4 sm:gap-8">
                        {footerLinks.map((link) =>
                            link.external ? (
                                <a
                                    key={link.label}
                                    href={link.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-base text-gray-500 hover:text-gray-900 transition-colors font-medium"
                                >
                                    {link.label}
                                </a>
                            ) : (
                                <Link
                                    key={link.label}
                                    href={link.href}
                                    className="text-base text-gray-500 hover:text-gray-900 transition-colors font-medium"
                                >
                                    {link.label}
                                </Link>
                            )
                        )}
                    </div>

                    {/* Copyright */}
                    {/* <div className="text-base text-gray-400">
                        &copy; {new Date().getFullYear()} Waitlistly
                    </div> */}
                </div>

                {/* Bottom tagline */}
                <div className="mt-8 pt-8 border-t border-gray-100 text-center">
                    <p className="text-gray-400">
                        Built for founders who validate before they build
                    </p>
                </div>
            </div>
        </footer>
    );
}
